import { getApps, getImageMod } from "./services";

export async function getAppsAction() {
  try {
    return (await getApps()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getImageModAction({ commit }, img) {
  try {
    return (await getImageMod(img)).data;
  } catch (e) {
    console.log(e);
  }
}
